import { Checkbox } from 'antd';
import React from 'react';

const RegisterCheckBox = ({ onClick, ...props }) => {
  return (
    <div>
      <Checkbox {...props} />
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */}
      <span
        className="checkbox-label"
        onClick={() => {
          onClick();
        }}
      >
        Kullanıcı Sözleşmesi
      </span>
    </div>
  );
};

export default RegisterCheckBox;
